module.exports = __webpack_public_path__ + "media/images/img_male-46ac5c08c8bce75903b377a2203c8fcc.png";